import React from 'react';
import Select from 'react-select';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';


export default class ProductScreen extends React.Component {

    constructor(props) {
        super(props);

        var programid = null;

        if (props.args.program)  {
            programid = props.args.program
        }

        this.state = {programOptions: [], 
                      programid: programid,    
                      currentProduct: {id: null, 
                                       name: "", 
                                       description: "",
                                       programid: programid,
                                       program: ""}};

        this.handleChangeName = this.handleChangeName.bind(this);  
        this.handleChangeDescription = this.handleChangeDescription.bind(this); 
        this.handleChangeProgram = this.handleChangeProgram.bind(this);
        this.save = this.save.bind(this);                         
    }

    async componentDidMount() {

        if (this.props.args.product && this.props.args.product.length > 0) {
            BaseApi.get("/product", {headers: {
                'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: this.props.args.product}, withCredentials: true})
            .then(res => { 
                this.setState({currentProduct: res.data})
            })    
            .catch()
        }

        
 
        BaseApi.get("/programs", {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => { 
            const programOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            this.setState({programOptions: programOptions})
        })    
        .catch()

        if (this.state.programid) {
            BaseApi.get("/program", {headers: {
                'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: this.state.currentProduct.programid}, withCredentials: true})
            .then(res => { 
                var program = res.data
                var currentProduct = this.state.currentProduct
                if (program) {
                    currentProduct.program = program.name
                    this.setState({сurrentProduct: currentProduct})
                }                     
            })   
            .catch()
        }    

    }


    save(event) {
        BaseApi.post('/product', this.state.currentProduct, {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            var currentProduct = this.state.currentProduct
            currentProduct.id = res.data.id
            this.setState({currentProduct: currentProduct})
            this.props.args.product = res.data.id
        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }

    handleChangeName(event) {
        var currentProduct = this.state.currentProduct
        currentProduct.name = event.target.value
        this.setState({currentProduct: currentProduct})
    }

    handleChangeDescription(event) {
        var currentProduct = this.state.currentProduct
        currentProduct.description = event.target.value
        this.setState({currentProduct: currentProduct})
    }

    handleChangeProgram(selectedOption) {
        var currentProduct = this.state.currentProduct
        currentProduct.program = selectedOption.label
        currentProduct.programid = selectedOption.value
        this.setState({currentProduct: currentProduct})
    }

    openEvents() {
        this.props.navigate("events", 
        {caller: "product", callargs: {product: this.state.currentProduct.id}, productid: this.state.currentProduct.id})

    }

    openRefs() {
        this.props.navigate("refs", 
        {caller: "product", callargs: this.props.args, refrecid: this.state.currentProduct.id})    
    }

    render() {

        const productExists = this.state.currentProduct.id;

        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.props.args} caption={"Продукт"}/>

                <div className="row mt-4">
                    <div className="col-lg-8">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">
                                    {productExists ? "Редактирование продукта" : "Новый продукт"}
                                </h6>
                                <form>
                                    <div class="form-group">
                                        <label for="name"> Наименование:</label>
                                        <input type="text" class="form-control w-100" id="name" value={this.state.currentProduct.name} onChange={this.handleChangeName} />
                                        <label for="description">Описание:</label>
                                        <input type="text" class="form-control w-100" id="description"  value={this.state.currentProduct.description} onChange={this.handleChangeDescription} />
                                        <label for="program">Программа:</label>
                                        {this.state.programid === null && 
                                            <Select options= {this.state.programOptions} 
                                                    id="program" 
                                                    onChange={this.handleChangeProgram}
                                                    placeholder={this.state.currentProduct.program}    
                                                    />
                                        }
                                        {this.state.programid !== null &&  
                                            <input type="text" class="form-control w-100" id="program" value={this.state.currentProduct.program} readonly="readonly"/>      
                                        } 

                                        <div className="mt-4 d-flex justify-content-end">
                                            <div class="row mt-3">
                                                <button class="btn btn-primary w-100" onClick={this.save}>Сохранить</button>   
                                            </div>
                                        </div>       
                                    </div>
                                </form>

                            </div>
                        </div>

                    </div>

                    <div className="col-lg-4 mt-4 mt-lg-0">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Действия</h6>
                                {productExists && (
                                    <div>
                                        <button 
                                            className="btn btn-outline-primary w-100 mb-2" 
                                            onClick={()=>{this.openEvents()}}
                                        >
                                            События
                                        </button>
                                        <button 
                                            className="btn btn-outline-primary w-100 mb-2"  
                                            onClick={()=>{this.openRefs()}}
                                        >
                                            Ссылки
                                        </button>

                                    </div>    
                                )}
                                {!productExists && (
                                    <p className="text-muted mb-0">
                                    Дополнительные действия станут доступны после сохранения записи.
                                    </p>
                                )}
                            </div>
                        </div>                    
                    </div>
                </div>
            </div> 
        )
    }

}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/product.js